import { useMutation, useQueryClient } from "@tanstack/react-query";
import { t } from "i18next";

import { errorHandler } from "#app/monitoring/errorHandler";
import { showErrorToast, showSuccessToast } from "#app/notifications";
import { updatePredictionFeedback } from "#modules/feedback/infra/updatePredictionFeedback.api";

import { predictionFeedbackQuery } from "../infra/predictionFeedback.query";

export const useUpdatePredictionFeedback = (params?: {
  options?: {
    onSuccess?: () => void;
    onError?: (err: Error) => void;
    onMutate?: () => void;
  };
}) => {
  const queryClient = useQueryClient();

  const { mutate, ...rest } = useMutation({
    mutationFn: updatePredictionFeedback,
    onMutate: () => {
      params?.options?.onMutate?.();
    },
    onSuccess: (predictionFeedback) => {
      void queryClient.invalidateQueries(predictionFeedbackQuery(predictionFeedback.predictionId));
      params?.options?.onSuccess?.();
      showSuccessToast({
        title: t("feedback.updated"),
        message: t("feedback.thankYou"),
      });
    },
    onError: (err: Error) => {
      showErrorToast({ title: err.message });
      errorHandler(err);

      params?.options?.onError?.(err);
      showErrorToast({
        title: t("feedback.error"),
        message: t("feedback.errorMessage"),
      });
    },
  });

  return { updatePredictionFeedback: mutate, ...rest };
};
